import AccOrdersTab from './accOrdersTab/AccOrdersTab.vue';
import NotesTab from './notesTab/NotesTab.vue';
import PurchasedAccProductsTab from './purchasedAccProductsTab/PurchasedAccProductsTab.vue';
import TagsTab from './tagsTab/Index.vue';
import AccProductReactionsTab from './accProductReactionsTab/AccProductReactionsTab.vue';
import ContactRequestsTab from './contactRequestsTab/ContactRequestsTab.vue';
import AccountsTab from './accountsTab/AccountsTab.vue';
import ImportErrorsTab from './importErrorsTab/ImportErrorsTab.vue';
import ActivityTab from './activityTab/ActivityTab.vue';
import ActivitiesTab from './activitiesTab/ActivitiesTab.vue';

export default {
  AccOrdersTab,
  NotesTab,
  PurchasedAccProductsTab,
  TagsTab,
  AccProductReactionsTab,
  ContactRequestsTab,
  AccountsTab,
  ImportErrorsTab,
  ActivityTab,
  ActivitiesTab,
};
